import type { SiteHealthCheck } from "@/types/tina";

/** Plain labels the owner reads daily (tina spec §5.2). */
export const CHECK_LABEL: Record<SiteHealthCheck, string> = {
  discover_failing: "Discover fails",
  discover_empty: "Discover finds 0 links",
  pages_unreadable: "Pages cannot be read",
  new_links_fade: "New links fade",
  social_quiet: "Instagram/Facebook quiet",
  mostly_junk: "Mostly junk",
  link_count_drop: "Link count falls",
  selector_empty: "Selector finds no rows",
  images_lost: "Posters not downloaded",
  cluttered: "Cluttered pages",
  tiers_missing: "Ticket tiers missing",
};

export function checkLabel(check: string): string {
  return (CHECK_LABEL as Record<string, string>)[check] ?? check;
}
